<!--
    描述：左侧菜单
    时间：2020-04-15
    Created by ws
-->
<template>
	<div class="w-left-menu">
		<el-scrollbar wrap-class="scrollbar-wrapper">
			<el-menu mode="vertical"
					 text-color="#fff"
					 background-color="#304156"
					 :default-active="activeMenu"
					 @select="handleClick"
					 :collapse="isCollapse"
					 class="w-menu">
				<template v-for="(item, index) in menuList">
					<el-submenu v-if="item.children && filterChildren(item.children).length > 0"
								:index="item.name"
								class="w-menu">
						<template slot="title">
							<svg-icon :icon-class="item.icon ? item.icon : ''" />
							<span class="ml10">{{ item.meta.title }}</span>
						</template>
						<el-menu-item v-for="(m, n) in filterChildren(item.children)"
									  :key="'menu.children' + n"
									  :index="m.name"
									  class="w-menu-item">
							<svg-icon :icon-class="m.icon ? m.icon : ''" />
							<span class="ml10">{{ m.meta.title }}</span>
						</el-menu-item>
					</el-submenu>

					<el-menu-item :index="item.name"
								  v-else
								  class="w-menu-item">
						<svg-icon :icon-class="item.icon ? item.icon : ''" />
						<span class="ml10"
							  slot="title">{{ item.meta.title }}</span>
					</el-menu-item>
				</template>

			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {}
	},
	methods: {
		// 菜单点击事件
		handleClick(index, indexPath) {
			let _index = this.routeList.findIndex(x => x.name === index)
			if (_index > -1) {
				this.$router.push({
					path: this.routeList[_index].path
				})
			}
		},

		// children 过滤
		filterChildren(list) {
			let backArr = list.filter(x => !x.hidden)
			return backArr
		}
	},
	computed: {
		...mapState('app', {
			isCollapse: state => state.isCollapse
		}),
		...mapState('menu', {
			activeRoutes: state => state.activeRoutes,
			routeList: state => state.routeList
		}),
		// 当前菜单
		activeMenu() {
			const route = this.$route
			const { name } = route

			return name
		},
		// 菜单列表
		menuList() {
			let arr = this.activeRoutes.find(x => x.name === 'Main')

			return arr.children.filter(x => !x.hidden)
		}
	}
}
</script>

<style lang="less">
.w-left-menu {
	// @bgColor: #86eaea;
	@bgColor: #304156;
	@hoverColor: #263445;
	@activeColor: #409EFF;

	height: 100%;
	overflow: hidden;
	background-color: @bgColor;
	border-right: 1px solid @bgColor;

	.el-scrollbar {
		height: 100%;

		.scrollbar-wrapper {
			overflow-x: hidden;
		}
	}

	.el-menu {
		border: none;
		height: 100%;
		width: 100% !important;
		background-color: @bgColor;
	}

	.el-submenu__title {
		&:hover {
			background-color: @hoverColor;
		}
	}

	.el-submenu {
		@sub-bg-color: #1f2d3d;

		.el-menu {
			background-color: @sub-bg-color;
		}

		.el-menu-item {
			background-color: @sub-bg-color;
		}

		.el-menu-item:hover {
			background-color: #001528;
		}
	}

	.w-menu-item {
		height: 46px;
		line-height: 46px;
		margin: 5px 0;

		&:hover,
		&:active {
			background-color: @hoverColor;
		}
	}

	// .w-menu-item.is-active {
	// 	color: @activeColor;
	// }
}
</style>
